import { useLazyQuery } from '@apollo/client';
import { useEffect, useState } from 'react';

import { OtherLienholderSlug } from '../constants/lienholders';
import { allLienholdersQuery } from '../gql/prs/lienholderGql';
import { Lienholder } from '../gql/prs/types';

interface useLienholdersHookType {
  lienholders: Lienholder[];
  probableLienholders: Lienholder[];
  loading: boolean;
}

export const useLienholders = ({ make, skip }: { make?: string | null; skip?: boolean }) => {
  const [lienholdersState, setLienholdersState] = useState<useLienholdersHookType>({
    lienholders: [],
    probableLienholders: [],
    loading: true,
  });

  const [getLienholders] = useLazyQuery<{ allLienholders: Lienholder[] }>(allLienholdersQuery, {
    onCompleted: ({ allLienholders }) => {
      const sortedLienholders = allLienholders
        .slice()
        .filter((lienholder) => lienholder.slug !== OtherLienholderSlug)
        .sort((a, b) => a.slug.localeCompare(b.slug));

      setLienholdersState({
        ...lienholdersState,
        lienholders: sortedLienholders,
        probableLienholders: sortedLienholders.filter(
          (lienholder) => lienholder.probableLienholder,
        ),
        loading: false,
      });
    },
  });

  useEffect(() => {
    if (skip) {
      setLienholdersState((prev) => ({ ...prev, loading: false }));
      return;
    }

    setLienholdersState({
      ...lienholdersState,
      loading: true,
    });

    getLienholders({ variables: { make: make || '' } });
  }, [make, skip]);

  return lienholdersState;
};

export default useLienholders;
